var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKpiAlertGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161169",
    "data-name": "Group 161169",
    transform: "translate(-36 -33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161139",
    "data-name": "Group 161139",
    transform: "translate(35.788 33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148041",
    "data-name": "Rectangle 148041",
    width: 26,
    height: 2,
    rx: 1,
    transform: "translate(0.212 2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_619",
    "data-name": "Ellipse 619",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(18.212)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161140",
    "data-name": "Group 161140",
    transform: "translate(36.442 43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148041-2",
    "data-name": "Rectangle 148041",
    width: 26,
    height: 2,
    rx: 1,
    transform: "translate(-0.442 2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_619-2",
    "data-name": "Ellipse 619",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(9.558)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161141",
    "data-name": "Group 161141",
    transform: "translate(36 53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148041-3",
    "data-name": "Rectangle 148041",
    width: 26,
    height: 2,
    rx: 1,
    transform: "translate(0 2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_619-3",
    "data-name": "Ellipse 619",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(2)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiAlertGrid);
export default __webpack_public_path__ + "static/media/KPI_AlertGrid.80331120ae57c957fa41310b6853aa13.svg";
export { ForwardRef as ReactComponent };